import React from "react";
import Paragraphs from "components/Paragraphs";
import classNames from "lib/classNames";

export default function ParagraphGrid({ data, level }) {
  const columns = parseInt(data.field_columns, 10);

  const gridCols = {
    1: "",
    2: "md:grid-cols-2",
    3: "md:grid-cols-2 lg:grid-cols-3",
    4: "md:grid-cols-2 lg:grid-cols-4",
  };

  return (
    <div className={classNames(columns === 1 && "mx-auto lg:max-w-screen-lg")}>
      {data.field_title && (
        <h2 className="mb-8 font-important text-4xl">{data.field_title}</h2>
      )}
      <div className={classNames("grid grid-cols-1 gap-8", gridCols[columns])}>
        <Paragraphs
          paragraphs={data.field_paragraphs}
          level={level + 1}
          vertical={columns > 2}
        />
      </div>
    </div>
  );
}
